import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { DekorPage } from './dekor/dekor';

@Component({
  selector: 'page-color',
  templateUrl: 'color.html',
})
export class ColorPage {
color: any;
selectedColor: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController ) {
  this.selectedColor = this.navParams.get('selectedColor');
  }
  
    selectColor(color){
    this.selectedColor = color;
    this.viewCtrl.dismiss({ color: this.selectedColor });
}

    closeModal(){
    this.viewCtrl.dismiss();
} 
  

  ionViewDidLoad() {
    console.log('ionViewDidLoad FenstertypPage');
  }
  
    ionViewWillEnter() : void
   {
    this.getColors();
   }
   
   
  getColors(){ 
  this.presentLoading();
  this.userService.getColors().subscribe((data : any) =>
      {
          this.colors = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getColors();
   refresher.complete();
   }

}


// WEBPACK FOOTER //
// ./src/pages/color/color.ts